import React from 'react';
import { Check } from 'lucide-react';
import Reveal from '../ui/Reveal';
import SpotCard from './SpotCard';

const CREDENTIALS = [
  'Ingeniera Mecatrónica titulada por la UNI.',
  'Docente y capacitadora en IA y tecnologías emergentes.',
  'Ha formado a profesionales, docentes y estudiantes.',
  'Experiencia en soluciones IoT, software e IA.',
  'Conferencista y ponente en espacios académicos.',
];

const TAGS = ['UNI', 'IA', 'IoT', 'Innovación'];

const InstructorSection: React.FC = () => {
  return (
    <section id="docente" className="relative scroll-mt-36 py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="mb-10">
          <div className="flex items-center gap-3">
            <span className="text-sm text-white/30">05</span>
            <span className="eyebrow-mc text-mc-electric/90">Conoce a tu docente</span>
          </div>
        </Reveal>

        <Reveal>
          <SpotCard className="grid gap-8 rounded-[28px] border border-white/10 bg-white/5 p-8 backdrop-blur-md md:grid-cols-[280px_1fr] md:gap-12 md:p-10">
            <div>
              <div
                className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/15"
                style={{ background: 'linear-gradient(150deg, rgba(218,35,157,.28), rgba(63,134,255,.28))' }}
              >
                <img
                  src="/images/04-capacitaciones/curso26agosto/docente_mirna.jpeg"
                  alt="Mirna Ampuero, docente del curso"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {TAGS.map((tag) => (
                  <span key={tag} className="chip-mc rounded-full px-3 py-1.5 text-xs text-white/70">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <h3 className="font-display text-2xl font-extrabold md:text-3xl">Mirna Ampuero</h3>
              <p className="mt-1 font-semibold text-gradient-mc">
                Ingeniera Mecatrónica — Universidad Nacional de Ingeniería (UNI)
              </p>
              <p className="mt-4 font-light leading-relaxed text-white/65">
                Profesional con experiencia en Inteligencia Artificial, innovación tecnológica, IoT y tecnologías
                emergentes, con trayectoria en desarrollo de proyectos y formación de estudiantes, docentes y
                profesionales.
              </p>
              <ul className="mt-6 grid gap-x-8 gap-y-2.5 text-sm sm:grid-cols-2">
                {CREDENTIALS.map((item) => (
                  <li key={item} className="flex items-start gap-2.5">
                    <Check size={16} className="mt-0.5 shrink-0 text-mc-fuchsia" />
                    <span className="text-white/75">{item}</span>
                  </li>
                ))}
              </ul>
              <blockquote className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-5 italic text-white/90 backdrop-blur-md">
                "La IA no reemplaza tu experiencia. Aprende a utilizarla para potenciar lo que puedes hacer con
                ella."
              </blockquote>
            </div>
          </SpotCard>
        </Reveal>
      </div>
    </section>
  );
};

export default InstructorSection;
